import React from 'react';
import { Link } from 'react-router-dom';
import { withRouteData } from 'react-static';

import '../styles/footer.scss';

export default withRouteData(({ t, lang, rootUrl }) => (
  <footer className="footer">
    <div className="content-wrap footer__line-wrapper">
      <div className="footer__line" />
    </div>
    <div className="footer__content">
      <div className="footer__items">
        <a
          href={`${process.env.GRC_URL}/rules?locale=${lang}`}
          target="_blank"
        >
          {t('header.rewardPlan')}
        </a>
        <Link to={`${rootUrl}faq`}>{t('header.faq')}</Link>
      </div>
      <a className="footer__copyright">{t('footer.copyright')}</a>
    </div>
    <div style={{ margin: '4px 8px', opacity: '0.6'}}>
      {process.env.REACT_APP_VERSION}
    </div>
  </footer>
));



// WEBPACK FOOTER //
// /app/apps/ms/src/components/Footer.js